import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b51fac38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[13px] ml-[6px] text-left text-[24px] font-bold leading-[160%] tracking-[-0.035em] text-white" }, " 제스처 미리보기 ", -1))
const _hoisted_2 = { class: "relative mb-5 flex h-[349px] w-full items-center justify-center overflow-hidden rounded-[20px] bg-[rgba(245,245,245,0.1)]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mb-5 flex w-full gap-5" }
const _hoisted_5 = {
  key: 0,
  class: "relative flex h-full w-full items-center justify-center transition-all"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "absolute flex items-center transition-all"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-[14px] font-bold leading-[136%] text-white" }, "미리듣기", -1))
const _hoisted_11 = { class: "mb-3 flex h-[179px] w-full flex-col rounded-[20px] bg-[rgba(245,245,245,0.1)] px-7 pt-6 pb-3" }
const _hoisted_12 = { class: "text-right text-[14px] font-bold leading-[136%] tracking-[-0.015em] text-white" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[rgba(131,144,165,1)]" }, "/200", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-7 text-[14px] font-normal leading-[136%] tracking-[-0.015em] text-[#8390A5]" }, [
  /*#__PURE__*/_createTextVNode(" * 음성을 선택한 후 미리듣기를 할 수 있습니다. 미리듣기할 때 영상은 반영되지 않습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" * 영상 제작에는 최대 4분까지 시간이 소요될 수 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" * 영상 제작 중 창을 끄거나 페이지를 이탈하실 경우, 영상 제작이 완료되지 않습니다."),
  /*#__PURE__*/_createElementVNode("br")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Video = _resolveComponent("Video")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@assets/icons/Loading.svg'),
        class: "absolute animate-spin"
      }, null, 8, _hoisted_3),
      _createVNode(_component_Video, {
        playsinline: "",
        muted: "",
        autoplay: "",
        loop: "",
        src: _ctx.props.src,
        class: "relative h-full w-full object-cover"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DropdownInput, {
        list: _ctx.languages,
        modelValue: _ctx.inputData.language,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputData.language) = $event)),
          _cache[1] || (_cache[1] = () => _ctx.$emit('input', _ctx.inputData))
        ]
      }, null, 8, ["list", "modelValue"]),
      _createVNode(_component_DropdownInput, {
        list: _ctx.actors,
        modelValue: _ctx.inputData.actor,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputData.actor) = $event)),
          _cache[3] || (_cache[3] = () => _ctx.$emit('input', _ctx.inputData))
        ]
      }, null, 8, ["list", "modelValue"]),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["relative flex flex-1 items-center justify-center rounded-[8px] border-2 border-solid border-[#6150FF] bg-[rgba(97,80,255,0.16)]", [{ 'pointer-events-none': _ctx.isLoading }]]),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleListen && _ctx.handleListen(...args)))
      }, [
        _createVNode(_TransitionGroup, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: require('@assets/icons/Loading.svg'),
                    class: "absolute h-9 animate-spin"
                  }, null, 8, _hoisted_6)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("img", {
                    src: require('@assets/icons/SmallPlay.svg'),
                    class: "mr-[5px] ml-[-6px]"
                  }, null, 8, _hoisted_8), [
                    [_vShow, !_ctx.isPlaying]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    src: require('@assets/icons/SmallPause.svg'),
                    class: "mr-[5px] ml-[-6px]"
                  }, null, 8, _hoisted_9), [
                    [_vShow, _ctx.isPlaying]
                  ]),
                  _hoisted_10
                ]))
          ]),
          _: 1
        }),
        _createElementVNode("audio", {
          ref: "audio",
          src: "",
          hidden: "",
          onEnded: _cache[4] || (_cache[4] = () => (_ctx.isPlaying = false))
        }, null, 544)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("textarea", {
        ref: "textarea",
        onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
        maxlength: "200",
        placeholder: "버추얼 휴먼이 말할 대사를 입력하세요. (200자 내)",
        class: "mb-3 h-full w-full resize-none bg-transparent text-[14px] font-normal leading-[136%] tracking-[-0.015em] text-white placeholder:text-white/60 focus:outline-none"
      }, null, 544),
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.inputData.text.length), 1),
        _hoisted_13
      ])
    ]),
    _hoisted_14
  ], 64))
}